module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aAuRu"))).then(() => parcelRequire('dJXJK'));